module.exports = __webpack_public_path__ + "static/media/slider-banner2.7fc21755.jpg";